import {Component, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {ToastrService} from "ngx-toastr";
import {Notification, NotificationType} from "../../../../../models/notification";
import {NotificationControllerService} from "../../../../../services/message-controller/notification-controller.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  providers: [NotificationControllerService],
})
export class NotificationComponent extends TranslatedBaseError implements OnInit {
  @Input() public hideList: boolean = false;
  public notificationList: Notification[];
  public serviceId: string;
  public userFilter: any = {content: ""};
  public baseUrl: string;

  public notification: Notification;
  public style: object = {};

  public showEdit: boolean = false;
  public showAdd: boolean = false;

  constructor(private notificationControllerService: NotificationControllerService,
              private route: ActivatedRoute,
              private router: Router,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/notification/";
    });
    this.loadNotificationsList();
  }

  public loadNotificationsList() {
    this.notificationControllerService.getNotificationsList(this.serviceId).subscribe(
      (data) => this.notificationList = data,
    );
  }

  public saveSortOrder(notifications: Notification[]) {
    const ids = [];
    if (notifications !== undefined) {
      notifications.forEach((n) => {
        ids.push(n.id);
      });
      this.notificationControllerService.sortNotifications(this.serviceId, ids).subscribe(

      );
    }
  }

  public saveDeterminant(notification) {
    notification.notificationType = NotificationType.GUIDE;
    this.notificationControllerService.saveNotification(notification).subscribe(
      (data) => {
        this.responseSuccessful("Message saved!");
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public deleteNotification(notification) {
    this.notificationControllerService.deleteNotification(notification.id).subscribe(
      (data) => {
        this.responseSuccessful("Message deleted!");
        this.loadNotificationsList();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public closeSlider() {
    this.loadNotificationsList();
    this.closeLayers();
  }

  public loadNotification(notification) {
    if (notification) {
      this.notification = this.notificationList.find((it) => {
        return it.id === notification.id;
      });
      this.showEdit = true;
    } else {
      this.notification = new Notification();
      this.showAdd = true;
    }
    }

    public sortNotification(event) {
        this.saveSortOrder(this.notificationList);
    }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }
}
